module.exports = __webpack_public_path__ + "img/diapositiva-2.91107a71.png";